import { TableRow } from "@mui/material";
import { ReactComponent as RemoveFilled } from "../../../../../../common/icons/delete.svg";
import { DatePicker } from "@mui/x-date-pickers";
import { StyledTableCell } from "../../../../../../common/components/functional/simpleTable/styled";
import { useEffect, useState } from "react";
import { DateRange } from "../../paymentProhibitionAPI";
import { isValid } from "date-fns";

interface Props {
  item: DateRange;
  disableExceptions: boolean;
  handleExceptionChange: (
    value: string,
    exceptionId: string,
    type: string,
    field: string,
  ) => void;
  deleteException: (exceptionId: string, type: string) => void;
}

const FreeMonthItem = ({
  item,
  disableExceptions,
  handleExceptionChange,
  deleteException,
}: Props) => {
  const [startDate, setStartDate] = useState<Date | null>(
    item?.start ? new Date(item.start) : null,
  );

  useEffect(() => {
    setStartDate(item?.start ? new Date(item.start) : null);
  }, [item]);

  const handleDateChange = (startDate: any) => {
    // Update local state with the new date
    setStartDate(startDate);
    // If the date is valid, update the item in paymentProhibitions with the new date
    if (startDate && isValid(startDate) && item?.id) {
      handleExceptionChange(startDate, item.id, "freeMonth", "start");
    }
  };

  return (
    <TableRow>
      <StyledTableCell sx={{ paddingLeft: "15px" }}>
        <DatePicker
          views={["year", "month"]}
          openTo="month"
          disabled={disableExceptions}
          format="MM/yyyy"
          value={startDate || null}
          onChange={(date) => handleDateChange(date)}
          slotProps={{
            textField: {
              size: "small",
              label: null,
              sx: {
                width: "135px",
                paddingTop: "0px",
                border: "none",
              },
            },
          }}
        />
      </StyledTableCell>
      <StyledTableCell>
        <RemoveFilled
          onClick={() =>
            !disableExceptions &&
            item?.id &&
            deleteException(item.id, "freeMonth")
          }
          style={{
            width: "16px",
            height: "16px",
            cursor: !disableExceptions ? "pointer" : "default",
            margin: "5px 10px 0px 5px",
            opacity: !disableExceptions ? 1 : 0.5,
          }}
        />
      </StyledTableCell>
    </TableRow>
  );
};
export default FreeMonthItem;
